import { createReducer } from 'reduxsauce'
import { Record, List } from 'immutable'
import { revisionTypes } from '.'

export const INITIAL_STATE = new Record({
	list: new List(),
	revision: {
		id: null,
		title: null,
		content: null,
		words: null,
		characters: null,
		updatedAt: null,
		updatedBy: {
			firstName: null,
			lastName: null,
		},
	},
})

export const getRevisionsSuccess = (state, { revisions }) =>
	state.set('list', new List(revisions))
export const getRevisionSuccess = (state, { revision }) =>
	state.merge({ revision })

export const reducer = createReducer(INITIAL_STATE(), {
	[revisionTypes.GET_REVISIONS_SUCCESS]: getRevisionsSuccess,
	[revisionTypes.GET_REVISION_SUCCESS]: getRevisionSuccess,
})
